module.exports = __webpack_public_path__ + "img/skridsko_botten.6503c18b.jpg";